const AllAuditTrail = () => import("./views/AllTransactionHistory.vue");
const TopupWallet = () => import("./views/TopupWallet.vue");
const Settings = () => import("./views/Settings.vue");
const ManageBusinessVerification = () =>
  import("./views/BusinessVerification.vue");

export default [
  {
    path: "view-all",
    component: AllAuditTrail,
  },
  {
    path: "topup-wallet",
    component: TopupWallet,
  },
  {
    path: "settings",
    component: Settings,
  },
  {
    path: "manage-business-verification",
    component: ManageBusinessVerification,
  },
  {
    path: "view-single",
    redirect: "/admin/payroll/payment-wallet/manage-business-verification",
  },
];
